// @flow
import React from 'react';
import EnableWaitlistModal from './EnableWaitlistModal';
import type { CountsByStatus } from '../types';
import MigrationStartedModal from './MigrationStartedModal';
import MigrationNotStartedModal from './MigrationNotStartedModal';

export type Props = {
  enable: {
    open: boolean,
    count: number,
    countsByStatus: CountsByStatus,
    onContinue: () => void,
    onCancel: () => void,
  },
  started: { open: boolean, onClose: () => void },
  notStarted: { open: boolean, onClose: () => void },
};

function WaitlistV2EnablementModals({ enable, started, notStarted }: Props) {
  return (
    <>
      <EnableWaitlistModal {...enable} />
      <MigrationStartedModal {...started} />
      <MigrationNotStartedModal {...notStarted} />
    </>
  );
}

export default WaitlistV2EnablementModals;
